import { render, staticRenderFns } from "./AddSubscription.vue?vue&type=template&id=50f950cd&scoped=true"
import script from "./AddSubscription.vue?vue&type=script&lang=js"
export * from "./AddSubscription.vue?vue&type=script&lang=js"
import style0 from "./AddSubscription.vue?vue&type=style&index=0&id=50f950cd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f950cd",
  null
  
)

export default component.exports